import { getErrorRes, getSuccessRes } from "../helpers/api-response";
import { handleErrorMessage } from "../helpers/handle-error-message";
import logger from "../helpers/logger";
import axiosIns from "../common/interceptor/axios-interceptor";

//Fetch Outage data
export const fetchOutageData = async () => {
  try {
    const res = await axiosIns.get(`rackstar/outage`);
    return getSuccessRes(res.data || [], "Outage data fetched successfully.");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to fetch Outage data.`);
  }
};

//Delete Outage
export const deleteOutageData = async (id) => {
  try {
    const res = await axiosIns.delete(`rackstar/outage/${id}`);
    return getSuccessRes(res.data || [], "Outage data deleted successfully.");
  } catch (error) {
    const errMessage = handleErrorMessage(error, true);
    throw getErrorRes(errMessage, `Failed to delete Outage data.`);
  }
};

// Update an existing outage entry
export const updateOutageData = async (id, data, toastId) => {
  try {
    const res = await axiosIns.put(
      `rackstar/outage/${id}`,
      data
    );
    return getSuccessRes(res.data, "Outage data updated successfully!");
  } catch (error) {
    logger.error("updateOutageData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to update Outage Data.");
  }
};

//Add a outage data
export const addOutageData = async (data, toastId) => {
  try {
    const res = await axiosIns.post(`rackstar/outage`, data);
    return getSuccessRes(res.data, "Outage data added successfully!");
  } catch (error) {
    logger.error("addOutageData", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to add outage data.");
  }
};

//Send Email
export const sendEmail = async (data, toastId) => {
  try {
    const res = await axiosIns.post(`email/outage`, data);
    return getSuccessRes(res.data, "Outage data and email sent successfully!");
  } catch (error) {
    logger.error("Email", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to send email and outage data.");
  }
};

//Fetch Outage Data With Filters
export const fetchOutageDataWithFilters = async (params) => {
  try {
    const res = await axiosIns.get(
      `rackstar/outage-with-filter`,
      { params }
    );
    return getSuccessRes(res.data || [], "Outage data fetched successfully.");
  } catch (error) {
    const errMessage = handleErrorMessage(error, false);
    throw getErrorRes(errMessage, `Failed to fetch Outage data.`);
  }
};

//Mark Expired Outages as Inactive
export const markExpiredOutagesInactive = async (toastId) => {
  try {
    const res = await axiosIns.post(`rackstar/outage/mark-expired-inactive`);
    return getSuccessRes(res.data || {}, res.data?.message || "Expired outages marked as inactive successfully.");
  } catch (error) {
    logger.error("markExpiredOutagesInactive", error);
    const errMessage = handleErrorMessage(error, true, toastId);
    throw getErrorRes(errMessage, "Failed to mark expired outages as inactive.");
  }
};